module.exports = __webpack_public_path__ + "img/appeal_status_icon_red.b2d4b251.svg";